export default (function (value) {
  return value;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/identity.js
// module id = 400
// module chunks = 0